<template>
  <v-container class="fill-height back" fluid>
    <DialogSyaratKetentuan/>
    <v-app-bar clipped-left app flat dark color="transparent">
      <img @click="home" class="logo" height="36" src="../assets/logoirsmarket1.png" alt="logo"/>
      <v-spacer/>
      <v-toolbar-items>
      </v-toolbar-items>
    </v-app-bar>
    <v-layout align-center justify-center>
      <v-flex xs12 sm6 md6 lg8>
        <v-card class="elevation-2">
          <v-layout wrap>
            <v-flex xs12 sm12 md12 lg8>
              <div style="height: 100%;background-size:100% 100%;background-image: url('https://cdn.irscloud.id/irsmarket/irsmarketlogin.png');" class="align-center hidden-sm-and-down">
              </div>
            </v-flex>
            <v-flex xs12 sm12 md12 lg4>
              <h1 class="text-center primary--text mt-2">IRSMarket</h1>
              <v-card-text>
                <v-form v-model="valid" ref="form" lazy-validation>
                  <v-text-field
                    v-model="newdata.nama"
                    name="name"
                    :rules="Rules"
                    required
                    label="Name"
                  ></v-text-field>
                  <v-text-field
                    v-model="newdata.email"
                    name="email"
                    :rules="emailRules"
                    required
                    type="email"
                    label="Email"
                  ></v-text-field>
                  <v-text-field
                    v-model="newdata.password"
                    name="password"
                    :rules="Rules"
                    required
                    type="password"
                    label="Password"
                  ></v-text-field>
                  <v-text-field
                    v-model="newdata.confmpassword"
                    name="confmpassword"
                    :rules="Rules"
                    required
                    type="password"
                    label="Confm Password"
                  ></v-text-field>
                  <div style="cursor:pointer;color: #1976d2" @click="setdialogsyarat(true)">Syarat & Ketentuan</div>
                  <v-checkbox
                    label="Saya setuju dengan syarat dan ketentuan"
                    v-model="checkbox"
                    :rules="[(v) => !!v || 'You must agree to continue!']"
                    required
                  >
                </v-checkbox>
                  <v-card-actions>
                    <v-btn
                      block
                      class="primary"
                      :disabled="!valid"
                      @click.native="handleSubmit()"
                      :loading="loading"
                    >Sign UP</v-btn>
                  </v-card-actions>
                  <div style="height:20px"></div>
                  <a href="#" class="magneta" @click.prevent="loginform()">Login to Accounnt</a>
                  <div style="height:20px"></div>
                </v-form>
              </v-card-text>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import DialogSyaratKetentuan from '@/components/DialogSyaratKetentuan'
var md5 = require('md5')
export default {
  name: 'signup',
  components: { DialogSyaratKetentuan },
  data: () => ({
    valid: false,
    dialogsyarat: false,
    checkbox: false,
    newdata: {
      nama: '',
      email: '',
      phone: '',
      password: '',
      confmpassword: '',
      hash: ''
    },

    emailRules: [
      v => !!v || 'E-mail is required',
      v =>
        // eslint-disable-next-line no-useless-escape
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        'E-mail must be valid'
    ],

    Rules: [v => !!v || 'Please fill'],
    submitted: false
  }),
  computed: {
    ...mapState('mitra', ['loading']),
    ...mapState('authentication', ['status', 'loading'])
  },
  created () {},
  methods: {
    ...mapActions({
      AddNew: 'mitra/Daftar',
      RegAkun: 'authentication/register'
    }),
    ...mapActions('PublicStore', ['setdialogsyarat']),
    handleSubmit () {
      if (this.valid) {
        this.$ga.event({
          eventCategory: 'Member',
          eventAction: 'Register',
          eventLabel: 'reg',
          eventValue: 1
        })
        if (this.newdata.password !== this.newdata.confmpassword) {
          this.$store.dispatch('alert/error', 'Password not match')
          return
        }
        if (!this.checkbox) {
          this.$store.dispatch('alert/error', 'Please agree to the terms and conditions')
          return
        }

        if (this.newdata.nama === '' || this.newdata.email === '' || this.newdata.password === '' || this.newdata.confmpassword === '') {
          this.$store.dispatch('alert/error', 'Please fill all fields')
          return
        }
        if (this.newdata.password.length < 6) {
          this.$store.dispatch('alert/error', 'Password must be at least 6 characters')
          return
        }
        if (this.newdata.password !== this.newdata.confmpassword) {
          this.$store.dispatch('alert/error', 'Password not match')
          return
        }
        if (this.newdata.nama.length < 3) {
          this.$store.dispatch('alert/error', 'Name must be at least 3 characters')
          return
        }
        if (this.newdata.email.length < 3) {
          this.$store.dispatch('alert/error', 'Email must be at least 3 characters')
          return
        }

        this.newdata.hash = md5('IRM' + this.newdata.nama + this.newdata.email + 'tuhanmemberkati')
        this.RegAkun(this.newdata)
        this.newdata.hash = ''
        this.newdata.nama = ''
        this.newdata.email = ''
        this.newdata.phone = ''
        this.newdata.password = ''
        this.newdata.confmpassword = ''
      }
    },
    loginform () {
      this.$router.push('/login')
    },
    register () {
      this.$router.push('/register')
    },
    forgot () {
      this.$router.push('/forgot')
    },
    home () {
      // this.$router.push('/')
      location.href = 'https://irsmarket.com'
    },
    login () {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.back {
  background-image: linear-gradient(to right, rgba(5, 11, 31, 0.8), rgba(5, 11, 31, 0.8)), url("https://irsx.sgp1.digitaloceanspaces.com/bglogintech.jpeg");
  background-size: cover;
}
a {
  text-decoration: none;
}
</style>
